<script lang="ts">
	//Hooks
	import { slide } from 'svelte/transition';
	//Helpers
	import { math_circular } from '../../../helpers/utilities';

	export let open: boolean | number = false,
		showItems = 6;

	let dataList: HTMLElement,
		scrollY = 0,
		hoveredIndex = NaN,
		selected = false;

	function initDataList(node: HTMLElement) {
		selected = false;
		hoveredIndex = NaN;
		dataList = node;
		const onScroll = () => {
			scrollY = dataList.scrollTop;
		};
		const onMouseEnter = (e: MouseEvent) => {
			const item = (<HTMLElement>e.target).closest(
				'.option:not(.hidden):not(.disabled)',
			) as HTMLElement;
			if (item) {
				const children: Array<HTMLElement> = Array.from(dataList.children) as Array<HTMLElement>;
				selected = false;
				clearHovered(children);
				item.classList.add('hovered');
				hoveredIndex = children.indexOf(item);
			}
		};
		const onMouseLeave = () => {
			selected = false;
			const children: Array<HTMLElement> = Array.from(dataList.children) as Array<HTMLElement>;
			clearHovered(children);
		};
		if (showItems) {
			dataList.style.maxHeight = `${
				(<HTMLElement>dataList.firstElementChild).offsetHeight *
				Math.min(dataList.children.length, showItems)
			}px`;
			dataList.style.scrollSnapType = 'y mandatory';
			dataList.scrollTop = scrollY;
			dataList.addEventListener('scroll', onScroll);
		}
		if (!('ontouchstart' in window)) {
			dataList.addEventListener('mouseover', onMouseEnter);
			dataList.addEventListener('mouseleave', onMouseLeave);
			document.addEventListener('keydown', handleKeydown);
		}
		return {
			destroy() {
				dataList.removeEventListener('scroll', onScroll);
				dataList.removeEventListener('mouseover', onMouseEnter);
				dataList.removeEventListener('mouseleave', onMouseLeave);
				document.removeEventListener('keydown', handleKeydown);
			},
		};
	}

	function handleKeydown(e: KeyboardEvent) {
		if (open) {
			const keyCode = e.key;
			if (keyCode == 'Escape') {
				open = false;
			} else if (keyCode == 'ArrowUp' || keyCode == 'ArrowDown') {
				e.preventDefault();
				let children: Array<HTMLElement> = Array.from(dataList.children) as Array<HTMLElement>;
				clearHovered(children);
				children = children.filter((item) => !/hidden|disabled/.test(item.className));
				selected = true;
				if (isNaN(hoveredIndex)) {
					hoveredIndex = keyCode == 'ArrowDown' ? -1 : 0;
				}
				hoveredIndex = math_circular(
					hoveredIndex + (keyCode == 'ArrowDown' ? 1 : -1),
					children.length,
				);
				const item: HTMLElement = children[hoveredIndex];
				item.classList.add('hovered');
				if (item.offsetTop < scrollY) {
					scrollY = item.offsetTop;
					dataList.scrollTop = scrollY;
				} else if (item.offsetHeight + item.offsetTop > scrollY + dataList.offsetHeight) {
					scrollY = item.offsetTop + item.offsetHeight - dataList.offsetHeight;
					dataList.scrollTop = scrollY;
				}
			} else if (selected && keyCode == 'Enter') {
				const children = dataList.children;
				(<HTMLElement>children[hoveredIndex]).click();
			}
		}
	}

	function clearHovered(children: Array<HTMLElement>) {
		const len = children.length;
		for (let i = 0; i < len; i++) {
			children[i].classList.remove('hovered');
		}
	}
</script>

<div class="select-data-list">
	{#if open}
		<div class="inner" use:initDataList transition:slide|global={{ duration: 350 }}>
			<slot />
		</div>
	{/if}
</div>

<style>
	.select-data-list {
		position: relative;
		overflow: auto;
	}

	.select-data-list > .inner {
		position: relative;
		overflow-x: hidden;
	}
</style>
